import { Alert, Button, Form, Input, Row, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import config from '../../config'
import useTranslation from '../../localization/useTranslation'
import LanguageToggler from '../../components/LanguageToggler/LanguageToggler'
import { getLanguageHeaders } from '../../store/services/http-common'

const ForgotPassword = () => {
    const [form] = Form.useForm()
    const { t, language } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(null)
    const [error, setError] = useState(null)

    const onFinish = async (values) => {
        setLoading(true)
        setError(null)
        setSuccess(null)

        try {
            const response = await fetch(`${config.apiUrl}/forgot-password`, {
                method: 'POST',
                body: JSON.stringify({ email: values.email }),
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    ...getLanguageHeaders(),
                },
            })

            const data = await response.json()

            if (!response.ok) {
                setError(data?.message ? t(data.message) : t('auth.forgotPassword.failed'))
                return
            }

            setSuccess(data?.message ? t(data.message) : t('auth.forgotPassword.success'))
        } catch (err) {
            setError(err?.message ?? t('auth.forgotPassword.failed'))
        } finally {
            setLoading(false)
        }
    }

    return (
        <Row style={{ height: '100vh', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ position: 'absolute', top: 12, right: 12, zIndex: 1000 }}>
                <LanguageToggler variant="round" />
            </div>

            <div style={{ width: 420, maxWidth: '92%', padding: 20, boxSizing: 'border-box' }}>
                <div style={{ textAlign: 'center', marginBottom: 8 }}>
                    <Typography.Title style={{ marginBottom: 8 }}>{t('auth.forgotPassword.title')}</Typography.Title>
                    <Typography.Paragraph type="secondary">{t('auth.forgotPassword.description')}</Typography.Paragraph>
                </div>

                {error ? <Alert message={error} type="error" showIcon closable style={{ marginBottom: 16 }} onClose={() => setError(null)} /> : null}
                {success ? <Alert message={success} type="success" showIcon style={{ marginBottom: 16 }} /> : null}

                <Form dir={language === 'ar' ? 'rtl' : 'ltr'} form={form} onFinish={onFinish} labelCol={{ span: 24 }}>
                    <Form.Item
                        name="email"
                        label={t('auth.login.email.label')}
                        rules={[
                            { required: true, message: t('auth.login.email.required') },
                            { type: 'email', message: t('auth.login.email.invalid') },
                        ]}
                    >
                        <Input type="email" placeholder={t('auth.login.email.placeholder')} />
                    </Form.Item>
                    <Form.Item>
                        <Button block type="primary" htmlType="submit" loading={loading}>
                            {t('auth.forgotPassword.submit')}
                        </Button>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0, textAlign: 'center' }}>
                        <Link to="/">{t('auth.forgotPassword.backToLogin')}</Link>
                    </Form.Item>
                </Form>
            </div>
        </Row>
    )
}

export default ForgotPassword
